import { Component } from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { datadogRum } from '@datadog/browser-rum';
import PropTypes from 'prop-types';
import { isDev } from '@utils/constants';

const PANEL_STYLE = {
  borderRadius: 5,
  padding: 15,
  textAlign: 'center'
};

const ICON_STYLE = {
  color: '#777',
  fontSize: 14,
  marginRight: 8
};

const MESSAGE_STYLE = {
  color: '#777',
  fontSize: 12
};

class ErrorBoundary extends Component {
  constructor (props) {
    super(props);

    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError () {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch (error, info) {
    this.setState({ error, hasError: true });

    if (!isDev) {
      datadogRum.addError(error, info);
    }
  }

  render () {
    const { border, message, marginBottom, style } = this.props;
    const { error } = this.state;
    const borderStyle = border ? { border: '1px solid #ccc' } : {};

    if (this.state.hasError) {
      return (
        <div style={{ ...PANEL_STYLE, ...borderStyle, marginBottom, ...style }}>
          <WarningOutlined style={ICON_STYLE} />
          {error && (
            <div style={MESSAGE_STYLE}>
              {message}
            </div>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.node.isRequired,
  marginBottom: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  message: PropTypes.string,
  style: PropTypes.shape()
};

ErrorBoundary.defaultProps = {
  border: false,
  marginBottom: 15,
  message: 'There was a problem loading this information. Please try again.',
  style: {}
};

export default ErrorBoundary;
